import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';

export interface IBankDeviseConverstionTauxFormMeta {
  bankId: FormInputMeta,
  bank: FormInputMeta,
  deviseId: FormInputMeta,
  devise: FormInputMeta,
  source: FormInputMeta,
  secondDeviseId: FormInputMeta,
  from: FormInputMeta,
  to: FormInputMeta,

  // Schema
  schema: any,
}

const BankDeviseConverstionTauxFormMeta: IBankDeviseConverstionTauxFormMeta = {} as IBankDeviseConverstionTauxFormMeta

BankDeviseConverstionTauxFormMeta.bankId = {
  name: 'bankId',
  type: 'text',
  label: 'ID Banque',
  placeholder: 'ID Banque',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.bank = {
  name: 'bank',
  type: 'text',
  label: 'Bank',
  placeholder: 'Bank',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.deviseId = {
  name: 'deviseId',
  type: 'text',
  label: 'ID Desive',
  placeholder: 'ID Devise',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.devise = {
  name: 'devise',
  type: 'text',
  label: 'Devise',
  placeholder: 'Devise',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.source = {
  name: 'source',
  type: 'select',
  label: 'Source',
  // placeholder: 'Source',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.secondDeviseId = {
  name: 'secondDeviseId',
  type: 'select',
  label: 'Deuxième ID Desive',
  // placeholder: 'Deuxième ID Desive',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.from = {
  name: 'from',
  type: 'date',
  label: 'De',
  // placeholder: 'Deuxième ID Desive',
  validation: yup.string().required(),
};

BankDeviseConverstionTauxFormMeta.to = {
  name: 'to',
  type: 'date',
  label: 'A',
  // placeholder: 'Deuxième ID Desive',
  validation: yup.string().required(),
};

const validationSchama = getValidationSchema(BankDeviseConverstionTauxFormMeta);

BankDeviseConverstionTauxFormMeta.schema = yup.object().shape(validationSchama);

export default BankDeviseConverstionTauxFormMeta;